import { Button, Space, Table } from 'antd';
import { t } from '@hefe/i18n';
import { ReloadOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../../store/store';
import { BasketballTeamSlice } from '@hefe/store';
import { useSelector } from 'react-redux';
import { formatDateTime } from '@hefe/utils';
import { UserBasic } from '@hefe/models';

interface TeamJudgesAutoAssignmentComponentProps {
  numberOfUsers: number;
}

export default function TeamJudgesAutoAssignmentComponent(
  props: TeamJudgesAutoAssignmentComponentProps
) {
  const dispatch = useAppDispatch();
  const previewData = useSelector(
    BasketballTeamSlice.basketballTeamJudgeGamesAutoAssignmentPreviewSelector
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchPreviewData();
  }, [props.numberOfUsers]);

  const fetchPreviewData = () => {
    setLoading(true);
    dispatch(
      BasketballTeamSlice.fetchBasketballTeamJudgeGamesAutoAssignmentPreview(
        props.numberOfUsers === 4
      )
    )
      .unwrap()
      .catch(() => null)
      .finally(() => setLoading(false));
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Button
        loading={loading}
        icon={<ReloadOutlined />}
        onClick={() => fetchPreviewData()}
      >
        {t('shuffle')}
      </Button>
      <Table
        key="team-judges-auto-assignment"
        loading={loading}
        dataSource={previewData}
        columns={[
          {
            title: t('date'),
            dataIndex: 'date',
            render: (date: string) => formatDateTime(date),
          },
          {
            title: t('gym'),
            dataIndex: 'gym',
          },
          {
            title: `${t('person')} 1`,
            dataIndex: 'judgePaper',
            render: (user?: UserBasic) =>
              user ? `${user?.firstname} ${user?.lastname}` : '---',
          },
          {
            title: `${t('person')} 2`,
            dataIndex: 'judgeTime',
            render: (user?: UserBasic) =>
              user ? `${user?.firstname} ${user?.lastname}` : '---',
          },
          {
            title: `${t('person')} 3`,
            dataIndex: 'judge24Sec',
            render: (user?: UserBasic) =>
              user ? `${user?.firstname} ${user?.lastname}` : '---',
          },
          {
            title: `${t('person')} 4`,
            dataIndex: 'judgePaperAsst',
            render: (user?: UserBasic) =>
              user ? `${user?.firstname} ${user?.lastname}` : '---',
          },
        ]}
      />
    </Space>
  );
}
